/**
 *  Delete Button
 *  Author: Luke
 *  CreatedAt: 2021-03-08
 */
import React from 'react';

import { DeleteOutlined } from '@ant-design/icons';

import css from './css.less';

const DeleteButton = (props) => {
  const { onClick, className, disable } = props;
  const _click = (e) => {
    if (!disable) {
      if (onClick) onClick(e);
    }
  };
  return (
    <DeleteOutlined
      onClick={_click}
      className={`${css.deleteIcon} ${disable ? css.disable : ''} ${className}`}
    />
  );
};
export default DeleteButton;
